import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

const SECTION_TEMPLATES = [
  {
    id: "table",
    title: "Table",
    description: "Organize information using rows and columns.",
    createSection: () => ({
      title: "Table Section",
      template: "table",
      type: "table",
      metadata: { columns: [], rows: [] },
    }),
  },
  {
    id: "quiz",
    title: "Quiz",
    description: "Add short formative questions for students.",
    createSection: () => ({
      title: "Quiz Section",
      template: "quiz",
      type: "quiz",
      metadata: { questions: [] },
    }),
  },
  {
    id: "highlight",
    title: "Highlight",
    description: "Share a key insight or callout for the assignment.",
    createSection: () => ({
      title: "Highlight Section",
      template: "highlight",
      type: "highlight",
      metadata: { emphasis: "info" },
    }),
  },
  {
    id: "media",
    title: "Media",
    description: "Embed video or audio instructions for students.",
    createSection: () => ({
      title: "Media Section",
      template: "media",
      type: "media",
      metadata: { sources: [] },
    }),
  },
  {
    id: "math-work",
    title: "Math / Work",
    description: "Prompt students to show their work or calculations.",
    createSection: () => ({
      title: "Work Section",
      template: "math-work",
      type: "math-work",
      metadata: { steps: [] },
    }),
  },
];

const AddSectionDialog = ({ open, onClose, onSelect }) => {
  const handleSelectTemplate = (template) => {
    if (!onSelect) {
      return;
    }

    const section = template.createSection();
    onSelect(section);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add a section</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {SECTION_TEMPLATES.map((template) => (
            <Grid item xs={12} sm={6} key={template.id}>
              <Box
                sx={{
                  border: (theme) => `1px solid ${theme.palette.divider}`,
                  borderRadius: 2,
                  p: 2.5,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: 2,
                  bgcolor: "background.paper",
                }}
              >
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }} gutterBottom>
                    {template.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {template.description}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  onClick={() => handleSelectTemplate(template)}
                  fullWidth
                >
                  {`Use ${template.title} template`}
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export { SECTION_TEMPLATES };
export default AddSectionDialog;
